module.exports = __webpack_public_path__ + "img/group_bail.15eb6df0.png";